import React, {memo, useContext, useMemo} from 'react';
import {useIntl} from 'react-intl';
import {ThemeContext} from '../../apiContexts';
import LoadingBar from '../../components/loadingBar';
import ReactTable from '../../components/reactTable';
import {convertDistanceTo, convertSpeedTo, convertVolumeTo, nomenclatureDistance, nomenclatureSpeedOf, nomenclatureVolume} from '../../helpers/conversions';
import {durationFormat} from '../../helpers/date';
import {getColumnWidth} from '../../helpers/report';
import {Header, ListStyle} from './styles';
import SelectDeviceButton from './selectDeviceButton';

const SummaryList = ({
  className,
  data,
  timezone,
  onSelect,
  speedUnit,
  distanceUnit,
  volumeUnit,
  loading,
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const intl = useIntl();

  const columns = useMemo(
      () => [
        {
          Header: intl.formatMessage({id: 'sharedName'}),
          accessor: 'deviceName',
          minWidth: 200,
          width: getColumnWidth(data, 'deviceName', intl.formatMessage({id: 'sharedName'})),
        },
        {
          Header: intl.formatMessage({id: 'sharedDistance'}),
          accessor: 'distance',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertDistanceTo(value, distanceUnit)).toFixed(2) ||
            0} ${nomenclatureDistance(distanceUnit)}`,
        },
        {
          Header: intl.formatMessage({id: 'reportStartOdometer'}),
          accessor: 'startOdometer',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertDistanceTo(value, distanceUnit)).toFixed(2) ||
            0} ${nomenclatureDistance(distanceUnit)}`,
        },
        {
          Header: intl.formatMessage({id: 'reportEndOdometer'}),
          accessor: 'endOdometer',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertDistanceTo(value, distanceUnit)).toFixed(2) ||
            0} ${nomenclatureDistance(distanceUnit)}`,
        },
        {
          Header: intl.formatMessage({id: 'reportAverageSpeed'}),
          accessor: 'averageSpeed',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertSpeedTo(value, speedUnit)).toFixed(1) ||
            0} ${nomenclatureSpeedOf(speedUnit)}`,
        },
        {
          Header: intl.formatMessage({id: 'reportMaximumSpeed'}),
          accessor: 'maxSpeed',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertSpeedTo(value, speedUnit)).toFixed(1) ||
            0} ${nomenclatureSpeedOf(speedUnit)}`,
        },
        {
          Header: intl.formatMessage({id: 'reportEngineHours'}),
          accessor: 'engineHours',
          Cell: ({cell: {value}}) => durationFormat(value, 'H [h] mm [m]'),
        },
        {
          Header: intl.formatMessage({id: 'reportStationaryHours'}),
          accessor: 'stationaryHours',
          Cell: ({cell: {value}}) => durationFormat(value, 'H [h] mm [m]'),
        },
        {
          Header: intl.formatMessage({id: 'reportIdleHours'}),
          accessor: 'idleEngineHours',
          Cell: ({cell: {value}}) => durationFormat(value, 'H [h] mm [m]'),
        },
        {
          Header: intl.formatMessage({id: 'reportSpentFuel'}),
          accessor: 'spentFuel',
          minWidth: 200,
          Cell: ({cell: {value}}) =>
            `${Number(convertVolumeTo(value, volumeUnit)).toFixed(1) ||
            0} ${nomenclatureVolume(volumeUnit)}`,
        },
      ],
      [data],
  );

  const selectItem = (props) => onSelect(props);

  return (
    <ListStyle theme={theme} className="custom-shadow-2">
      <Header>
        <h5>{intl.formatMessage({id: 'summaries'})}</h5>
        <SelectDeviceButton />
      </Header>
      {loading ? (
        <LoadingBar />
      ) : (
        <ReactTable
          data={data}
          columns={columns}
          selectItem={selectItem}
          listHeight={300}
        />
      )}
    </ListStyle>
  );
};

export default memo(SummaryList);
